import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgBusyModule } from 'ng-busy';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule, MobileUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { CartOrderLineInfoComponent } from './components/cart-order-line-info/cart-order-line-info.component';
import { CartBtnComponent } from './components/cart-btn/cart-btn.component';
import { CartLineImgComponent } from './components/cart-cake-img/cart-line-img.component';
import { CartPromoCodeNGiftCardComponent } from './components/cart-promo-code-n-gift-card/cart-promo-code-n-gift-card.component';
import { CartDeliveryComponent } from './components/cart-delivery/cart-delivery.component';
import { CartBtnQuantityPriceComponent } from './components/cart-btn-quantity-price/cart-btn-quantity-price.component';
import { CartShowAndCheckoutComponent } from './components/cart-show-and-checkout/cart-show-and-checkout.component';
import { CartShowAndCheckoutFooterComponent } from './components/cart-show-and-checkout-footer/cart-show-and-checkout-footer.component';
import { CartV2Component } from './components/cart-v2/cart-v2.component';
import { CartDiscountedPriceComponent } from './components/cart-discounted-price/cart-discounted-price.component';
import { MobileCartComponent } from './components/mobile-cart/mobile-cart.component';
import { MobileCartFooterComponent } from './components/mobile-cart-footer/mobile-cart-footer.component';
import { MobileCartProductItemComponent } from './components/mobile-cart-product-item/mobile-cart-product-item.component';
import { MobilePromoCodeSectionComponent } from './components/mobile-promo-code-section/mobile-promo-code-section.component';
import { MobileCartApplyOnceItemComponent } from './components/mobile-cart-apply-once-item/mobile-cart-apply-once-item.component';
import { CartReturnPackagingComponent } from './components/cart-return-packaging/cart-return-packaging.component';

const COMPONENTS = [
  CartOrderLineInfoComponent,
  CartBtnComponent,
  CartLineImgComponent,
  CartPromoCodeNGiftCardComponent,
  CartDeliveryComponent,
  CartBtnQuantityPriceComponent,
  CartShowAndCheckoutComponent,
  CartShowAndCheckoutFooterComponent,
  CartDiscountedPriceComponent,
  CartV2Component,
  MobileCartComponent,
  MobileCartFooterComponent,
  MobileCartProductItemComponent,
  MobileCartApplyOnceItemComponent,
  MobilePromoCodeSectionComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgBusyModule,
    TranslateModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    ScrollToModule,
    MobileUiModule,
    MobileUiModule,
    CakeItEasyWebUiModule,
    CartReturnPackagingComponent,
  ],
  exports: [
    ...COMPONENTS,
    CartReturnPackagingComponent,
  ],
  declarations: [
    ...COMPONENTS
  ],
})
export class CartUiModule {
}
